import { AnimationRefs } from '../../../hooks/use-animation-refs';
import { Viewport } from '../../../hooks/use-viewport';
import { animateStars } from '../../helpers/animate-stars';

export function buildStage10(tl: GSAPTimeline, refs: AnimationRefs, viewport: Viewport) {
  const { vw, vh } = viewport;

  animateStars({
    tl,
    stars: refs.stars,
    label: 'stage10',
    animations: [
      {
        x: vw(-0.315),
        y: vh(-0.2479),
        duration: 5,
        yoyo: true,
        repeat: 1,
      },
      {
        x: vw(0.1),
        y: vh(-0.205),
        duration: 5,
        yoyo: true,
        repeat: 1,
      },
      {
        x: vw(-0.43),
        y: vh(-0.44),
        duration: 5,
        yoyo: true,
        repeat: 1,
      },
      {
        x: vw(0.39),
        y: vh(-0.336),
        duration: 5,
        yoyo: true,
        repeat: 1,
      },
      {
        x: vw(0.29),
        y: vh(-0.558),
        duration: 5,
        yoyo: true,
        repeat: 1,
      },
      {
        x: vw(-0.155),
        y: vh(-0.568),
        duration: 5,
        yoyo: true,
        repeat: 1,
      },
    ],
  });
}
